import { Component, OnInit } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { ConfigService } from '../../../services/config.service'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss']
})
export class ImprintComponent implements OnInit {
  public currentLanguage: string

  constructor(private configService: ConfigService,
              private translateService: TranslateService,
              private title: Title,
              private meta: Meta,
  ) {}

  public ngOnInit() {
    this.currentLanguage = this.configService.getCurrentLanguage()

    this.translateService.get('meta.imprint.title').toPromise().then(title => {
      this.title.setTitle(title)
    })

    this.translateService.get('meta.imprint.description').toPromise().then( content => {
      this.meta.updateTag({
        name: 'description',
        content,
      }, `description='description'`)
    })
  }
}
